import React from 'react';
import studentOverviewStore from './StudentOverview.store';
import LoadingIndicator from 'generic/LoadingIndicator.react';
import LineChart from 'generic/LineChart/LineChart.react';
import TeacherClassroomScope from '../../TeacherClassroomScope/TeacherClassroomScope.react';
import teacherClassroomScopeStore from '../../TeacherClassroomScope/TeacherClassroomScope.store';

import './student-overview.scss';

export default class StudentOverview extends React.Component {
  getStatisticalSummary() {
    if (!teacherClassroomScopeStore.getDateRangeStore().isValid()) {
      return null;
    }

    if (!studentOverviewStore.hasStudentTimeSeriesData()) {
      return (
        <div className='single-student-overview__statistical-summary'>
          <div className='single-student-overview__statistical-summary-item'>
            <LoadingIndicator inline={true} />
          </div>
          <div className='single-student-overview__statistical-summary-item'>
            <LoadingIndicator inline={true} />
          </div>
          <div className='single-student-overview__statistical-summary-item'>
            <LoadingIndicator inline={true} />
          </div>
          <div className='single-student-overview__statistical-summary-item'>
            <LoadingIndicator inline={true} />
          </div>
        </div>
      );
    }

    const intervalSummaryData = studentOverviewStore.getIntervalDataSummary();
    return (
      <div className='single-student-overview__statistical-summary'>
        <div className='single-student-overview__statistical-summary-item'>
          <h5 className='single-student-overview__statistical-summary-item-heading'>
            Total questions answered
          </h5>
          <div className='single-student-overview__statistical-summary-item-body'>
            {intervalSummaryData.getTotalQuestionsAnswered()}
          </div>
        </div>
        <div className='single-student-overview__statistical-summary-item'>
          <h5 className='single-student-overview__statistical-summary-item-heading'>
            Total points earned
          </h5>
          <div className='single-student-overview__statistical-summary-item-body'>
            {intervalSummaryData.getSumOfPointsEarned()}
          </div>
        </div>
        <div className='single-student-overview__statistical-summary-item'>
          <h5 className='single-student-overview__statistical-summary-item-heading'>
            Total time spent
          </h5>
          <div className='single-student-overview__statistical-summary-item-body single-student-overview__statistical-summary-item-body--time'>
            {intervalSummaryData.getTimeSpentGuessing()}
          </div>
        </div>
        <div className='single-student-overview__statistical-summary-item'>
          <h5 className='single-student-overview__statistical-summary-item-heading'>Accuracy</h5>
          <div className='single-student-overview__statistical-summary-item-body'>
            {intervalSummaryData.getAverageAccuracy()}%
          </div>
        </div>
      </div>
    );
  }

  getTimeSeriesGraphs() {
    if (!teacherClassroomScopeStore.getDateRangeStore().isValid()) {
      return null;
    }

    if (!studentOverviewStore.hasStudentTimeSeriesData()) {
      return (
        <div className='single-student-overview__statistical-graphs'>
          <LoadingIndicator />
        </div>
      );
    }

    const intervalChartData = studentOverviewStore.getIntervalChartData();
    const timeSpentData = intervalChartData.getTimeSpentData();
    return (
      <div className='single-student-overview__statistical-graphs'>
        <div className='single-student-overview__statistical-graph'>
          <h4>Questions Answered</h4>
          <LineChart
            color='red'
            data={intervalChartData.getQuestionsAnsweredData()}
            storeName='student-time-series-questions-answered'
            tooltipMessage='questions answered'
            selectedInterval={studentOverviewStore.getInterval()}
          />
        </div>
        <div className='single-student-overview__statistical-graph'>
          <h4>Accuracy</h4>
          <LineChart
            color='blue'
            data={intervalChartData.getAccuracyData()}
            storeName='student-time-series-accuracy'
            tooltipMessage='% accuracy'
            selectedInterval={studentOverviewStore.getInterval()}
          />
        </div>
        <div className='single-student-overview__statistical-graph'>
          <h4>Time Spent</h4>
          <LineChart
            color='purple'
            data={timeSpentData}
            storeName='student-time-series-time-spent'
            tooltipMessage='hours spent'
            selectedInterval={studentOverviewStore.getInterval()}
          />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className='single-student-overview'>
        <div className='single-student-overview__filter-set'>
          <TeacherClassroomScope />
        </div>
        {this.getStatisticalSummary()}
        {this.getTimeSeriesGraphs()}
      </div>
    );
  }
}
